import axios from 'axios';

import routes from 'app/routes';

export default {
  setPolicyPlanFilter: (dispatch, currentFilters, selectedOption) => {
    const filters = {
      ...currentFilters,
      policyPlanId: selectedOption ? selectedOption.map((item) => item.value) : null,
    };

    dispatch({ type: 'SET_FILTERS', filters });
  },

  setTeamFilter: (dispatch, currentFilters, selectedOption) => {
    const filters = {
      ...currentFilters,
      teamId: selectedOption ? selectedOption.map((item) => item.value) : null,
      cycleId: null,
    };

    dispatch({ type: 'SET_FILTERS', filters });
  },

  setCycleFilter: (dispatch, currentFilters, selectedOption) => {
    const filters = {
      ...currentFilters,
      cycleId: selectedOption ? selectedOption.value : null,
    };

    dispatch({ type: 'SET_FILTERS', filters });
  },

  loadStatistics: (dispatch, filters, afterCallback) => {
    const params = {
      policy_plan_id: filters.policyPlanId,
      team_id: filters.teamId,
      cycle_id: filters.cycleId,
    };

    axios
      .get(routes.api.managers.dashboard.statistics, { params })
      .then((response) => {
        dispatch({ type: 'LOAD_STATISTICS', statistics: response.data.data });
        afterCallback();
      });
  },

  generateReport: (urlParams) => {
    axios
      .get(routes.managers.dashboard.report(urlParams))
      .then((_response) => {
      });
  },
};
